<div class="notifications-history">
    <app-alert *ngIf="sameDay"
        [message]="'Date range cannot be the same day, please reapply'"
        level="error"
        [dismissDelay]="5000">
    </app-alert>
    <mat-list>
        <div class="column-grid tw-justify-between tw-place-items-center tw-px-4" data-cy="notifications-history-menu">
            <h3 class="!tw-mb-0 tw-whitespace-nowrap" data-cy="notifications-history-header">Notifications History</h3>
            <div class="column-grid">
                <mat-date-range-input class="tw-invisible" [rangePicker]="picker" [formGroup]="range" [min]="minDate" [max]="today">
                    <input matStartDate formControlName="start" placeholder="Start date" (dateChange)="handleDate()">
                    <input matEndDate formControlName="end" placeholder="End date" (dateChange)="handleDate()">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [disableRipple]="true" [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              <button mat-icon-button
                      [matMenuTriggerFor]="activity">
                <mat-icon>filter_alt</mat-icon>
              </button>
                <mat-menu  #activity="matMenu" class="tw-p-2">
                    <div class="column-grid tw-place-items-center">
                        <button
                            class=""
                            mat-button
                            (click)="handleSelectAllTypes(); $event.stopPropagation()">
                            Select All
                        </button>
                        <button
                            [disabled]="!notificationTypes.length"
                            mat-button
                            (click)="handleClearTypes(); $event.stopPropagation()">
                            Clear
                        </button>
                    </div>
                    <p *ngFor="let notificationType of notificationList">
                        <mat-checkbox
                            [(ngModel)]="notificationType.checked"
                            [checked]="notificationType.checked"
                            (change)="handleNotificationType($event, notificationType)"
                            (click)="$event?.stopPropagation?.()">
                            {{ notificationType.title }}
                        </mat-checkbox>
                    </p>
                </mat-menu>
            </div>
        </div>
        <div class="tw-flex tw-pl-3.5 tw-pb-2.5">
            <div *ngIf="notificationTypes && notificationTypes.length === 1" class="tw-pr-1.5">
                <mat-chip>{{ notificationTypes[0].title }}
                    <button matChipRemove (click)="handleClearTypes()">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
            </div>
            <div *ngIf="notificationTypes && notificationTypes.length >= 2" class="tw-pr-1.5">
                <mat-chip>{{ notificationTypes[0].title }} and {{ notificationTypes.length - 1 }} others
                    <button matChipRemove (click)="handleClearTypes()">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
            </div>
            <div *ngIf="start && end">
                <mat-chip>{{ start | date: 'MMM d'}} - {{ end | date: 'MMM d' }}
                    <button matChipRemove (click)="handleClearDates()">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
            </div>
        </div>
        <mat-divider></mat-divider>
        <div mat-subheader *ngIf="notifications && !notifications.length">No notifications yet, but don't worry, you
            will have some very soon.</div>
    </mat-list>
    <div *ngIf="notifications && notifications.length">
        <mat-card *ngFor="let notification of notifications" (click)="navigateTo(notification)"
            class="tw-cursor-pointer !tw-shadow-none notification-history tw-pb-2">
          <mat-card-content>
            <div class="column-grid tw-gap-4 tw-grid-cols-[auto_1fr]">
              <div class="column-grid tw-place-items-center">
                <mat-icon>{{ notification.icon }}</mat-icon>
              </div>
              <div class="column-grid tw-justify-between !tw-text-base">
                <div>
                  <div class="!tw-font-medium">{{ notification.title }}</div>
                  <div>{{ notification.businessName }}</div>
                </div>
                <span>{{ notification.timestamp * 1000 | timeago }}</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
    </div>
    <div class="tw-mt-4 tw-mb-4 tw-flex tw-justify-center">
        <button
            mat-flat-button
            color="primary"
            *ngIf="!loading && !nextPageLoading && !noMoreNotifications && notifications && notifications.length"
            (click)="handleNextPage(); $event.stopPropagation()">
            <span class="progress-button-text">Load More</span>
        </button>
        <div *ngIf="nextPageLoading">
            Loading More Results...
        </div>
        <div *ngIf="noMoreNotifications">
            You've reached the end of the rainbow <mat-icon class="tw-translate-x-px tw-translate-y-1.5">looks</mat-icon>
        </div>
    </div>
</div>
